module.exports = __webpack_public_path__ + "img/nodejs.e7577098.png";